/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/2/2023
 */

export const CoachType = Object.freeze({
	GENERAL: "GENERAL",
	IAOTRC: "IAOTRC",
	TRAUMA_COACH: "TRAUMA_COACH",
	ADDICTION_COACH: "ADDICTION_COACH",
	BUSINESS_COACH: "BUSINESS_COACH",
	LIFE_COACH: "LIFE_COACH",
	FAMILY_COACH: "FAMILY_COACH",
	OTHER: "OTHER",
})

export const CoachTypeList = [
	{
		label: "IAOTRC coach",
		type: CoachType.IAOTRC,
		description: "Select this option if you are IAOTRC certified coach or planning to become one."
	},
	{
		label: "Trauma Recovery Coach",
		type: CoachType.TRAUMA_COACH,
		description: ""
	},
	{
		label: "Addiction Recovery Coach",
		type: CoachType.ADDICTION_COACH,
		description: ""
	},
	{
		label: "Business Coach",
		type: CoachType.BUSINESS_COACH,
		description: ""
	},
	{
		label: "Life Coach",
		type: CoachType.LIFE_COACH,
		description: ""
	},
	{
		label: "Family Therapy Coach",
		type: CoachType.FAMILY_COACH,
		description: ""
	},
]
